import { createApp } from "vue"
import SearchInputField from "./SearchInputField"

const el = ".nyk-component--search-input-field"

export default function (Store) {
  const DOM = document.querySelectorAll(el)
  if (DOM.length) {
    DOM.forEach((SearchInputFieldDOM) => {
      const props = {
        searchIconLabel: SearchInputFieldDOM.dataset.searchIconLabel,
        closeIconLabel: SearchInputFieldDOM.dataset.closeIconLabel,
        placeholder: SearchInputFieldDOM.dataset.placeholder,
        ariaLabel: SearchInputFieldDOM.dataset.ariaLabel,
        initSearchParam: SearchInputFieldDOM.dataset.initSearchParam,
        onChangeCallback: SearchInputFieldDOM.dataset.onChangeCallback ?? null,
        onEnterCallback: SearchInputFieldDOM.dataset.onEnterCallback ?? null,
        redirectUrl: SearchInputFieldDOM.dataset.redirectUrl ?? null,

        searchInputAriaLabel: SearchInputFieldDOM.dataset.searchInputAriaLabel,
        searchButtonAriaLabel: SearchInputFieldDOM.dataset.searchButtonAriaLabel,
        searchResetAriaLabel: SearchInputFieldDOM.dataset.searchResetAriaLabel,
      }

      const component = createApp(SearchInputField, props).use(Store)
      component.mount(SearchInputFieldDOM)
    })
  }
}
